import type { BrowserInfo, DeviceInfo, LocationInfo } from '@/modules/core/models/info.model'

export interface Login {
  email: string
  password: string
  deviceInfo?: DeviceInfo | null
  locationInfo?: LocationInfo | null
  browserInfo?: BrowserInfo | null
  timestamp?: string | null
  timezone?: string | null
  loginAttemptCount?: number | null
  recaptchaToken?: string
}

export const emptyLogin: Login = {
  email: '',
  password: '',
  recaptchaToken: '',
}

export const adminLogin: Login = {
  email: 'john.doe@staroil.com',
  password: 'Qwert123',
  recaptchaToken: '',
}

export function isLogin(value: unknown): value is Login {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as Record<string, unknown>).email === 'string' &&
    typeof (value as Record<string, unknown>).password === 'string'
  )
}
